export default [
  { label: 'Quizzes', value: 'Quizzes' },
  { label: 'Bite-Sized Training', value: 'Bite-Sized Training' },
  { label: 'Videos', value: 'Videos' },
  { label: 'Learning Streams', value: 'Learning Streams' },
  { label: 'Coaching Forum', value: 'Coaching Forum' },
  { label: 'Book Insights', value: 'Book Insights' },
  { label: 'Expert Interviews', value: 'Expert Interviews' }
]
